import React, { useState, useEffect } from 'react';
import spin from './img/spin-icon.svg';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import { SpinWheel, SpinWheelRoulette, SpinWheelSlice, SpinWheelSliceText, SpinWheelSpin, SpinWheelWrapper, SpinWheelWrapperCount } from '@/components/custom/spin-wheel';

export default function WeekChallengeSpinWheel() {
  const [rotate, setRotate] = useState(0);

  const { currentChallenge, setCurrentTaxonomy, currentRound, getTaxonomies, taxonomies } = useWeeklyChallenge();

  useEffect(() => {
    if (currentChallenge) getTaxonomies();
  }, []);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * taxonomies?.length);
    const rotateValue = 360 / taxonomies?.length;
    setTimeout(() => setRotate(randomIndex * rotateValue + 1440), 500);
    setCurrentTaxonomy(taxonomies[randomIndex]);
  }, [taxonomies]);

  return (
    <SpinWheelWrapper>
      <SpinWheelWrapperCount>Rodada {currentRound}</SpinWheelWrapperCount>

      <SpinWheel>
        <SpinWheelRoulette
          slices={taxonomies?.length}
          rotate={rotate}
        >
          {taxonomies?.map((slice, i) => {
            const rotateValue = 360 / taxonomies?.length;
            const rotate = rotateValue * i;

            return (
              <SpinWheelSlice
                key={i}
                bg={slice?.color}
                rotate={rotate}
                slices={taxonomies?.length}
              >
                <SpinWheelSliceText title={slice?.name}>{slice?.name}</SpinWheelSliceText>
              </SpinWheelSlice>
            );
          })}
        </SpinWheelRoulette>

        <SpinWheelSpin
          src={spin}
          alt="ícone de girar"
        />
      </SpinWheel>
    </SpinWheelWrapper>
  );
}
